import { useNavigate } from 'react-router-dom';

const NINERS_LOGO = "https://customer-assets.emergentagent.com/job_7442c566-20f0-4c0f-8d05-f273c41d0090/artifacts/usp3jo2t_DSV_Niners_Logo.png";

function Logo({ size = 'md' }) {
  const navigate = useNavigate();
  
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-12 h-12 sm:w-16 sm:h-16',
    xl: 'w-16 h-16 sm:w-20 sm:h-20',
    '2xl': 'w-20 h-20 sm:w-24 sm:h-24'
  };

  return (
    <button 
      onClick={() => navigate('/dashboard')}
      className="hover:opacity-80 transition-opacity cursor-pointer"
      title="Go to Dashboard"
    >
      <img 
        src={NINERS_LOGO}
        alt="DSV Niners"
        className={`${sizeClasses[size]} object-contain`}
      />
    </button>
  );
}

export default Logo;
